<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { GET_VEHICLE } from '@/services/api/master/fleet'
import {
  GET_VEHICLE_GROUP_DETAIL,
  UPDATE_VEHICLE_GROUP,
  CREATE_VEHICLE_GROUP,
} from '@/services/api/setting/fleet/fleetGroup'
import { GET_VEHICLE_TYPE } from '@/services/api/setting/fleet/fleetType'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import McGrapqlTable from '@/components/McGrapqlTable'
import { Helper } from '@/mixin/helper'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McButton,
    McGrapqlTable,
  },

  mixins: [Helper],
  apollo: {
    vehicles: {
      query: GET_VEHICLE,
    },
    vehicleTypes: {
      query: GET_VEHICLE_TYPE,
    },
    vgroup: {
      query: GET_VEHICLE_GROUP_DETAIL,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            id: parseInt(this.$route.params.id),
          },
        }
      },
      skip() {
        return !this.$route.params.id && this.$route.params.id === undefined
      },
      result({ data, loading }) {
        if (!loading) this.form.vgroup = data.vgroup.vgroup.name
      },
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      selected: {
        groupVehicleList: [],
        vehicleList: [],
      },
      selectedModel: {
        groupVehicleList: [],
        vehicleList: [],
      },
      vehicles: {
        vehicles: [],
      },
      vgroup: {
        vgroup: {
          name: '',
          vehicleList: [],
        },
      },
      vehicleTypes: {
        vehicleTypes: {
          data: [],
        },
      },

      initialObject: {
        vehicleType: null,
      },
      fullObject: {
        vehicleType: null,
        manufacturers: {},
        types: {},
      },

      fleet_type: null,

      manufacturerFilter: [],
      typeFilter: [],
      statusFilter: [],
      refreshMainTable: false,
      refreshModalTable: false,
      form: {
        vgroup: null,
      },
      isSubmitted: false,
    }
  },

  computed: {
    /**
     * Total no. of records
     */
    title() {
      return this.$t('setting.list.fleetGroup.form.createFleetGroup')
    },

    items() {
      return [
        {
          text: this.$t('setting.list.fleetGroup.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.fleetGroup.groupFleet'),
          to: '/setting/fleetgroup',
        },
        {
          text:
            !this.$route.params.id && this.$route.params.id === undefined
              ? this.$t('setting.list.fleetGroup.form.createFleetGroup')
              : 'Ubah Grup Kendaraan',
        },
      ]
    },

    groupVehicleList() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('setting.list.fleetGroup.form.licensePlate'),
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
        {
          key: 'manufacturer',
          label: this.$t('setting.list.fleetGroup.manufacture'),
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
        {
          key: 'category',
          label: this.$t('setting.list.fleetSetting.fleetCategory'),
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
        {
          key: 'vehicleType',
          label: this.$t('setting.list.fleetGroup.form.fleetType'),
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
        {
          key: 'imei',
          label: 'IMEI',
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
      ]
    },
    vehicleList() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('setting.list.fleetGroup.form.licensePlate'),
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
        {
          key: 'manufacturer',
          label: 'Manufaktur',
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
        {
          key: 'category',
          label: 'Kategori Kendaraan',
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
        {
          key: 'vehicleType',
          label: this.$t('setting.list.fleetGroup.form.fleetType'),
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
        {
          key: 'imei',
          label: 'IMEI',
          thClass: 'mc-table--50',
          isSortable: true,
          shown: true,
        },
      ]
    },

    linkedVehicle() {
      return this.vgroup.vgroup.vehicleList
    },

    vehicleOptions() {
      let linked = this.linkedVehicle.map((item) => item.id)

      let options = this.vehicles.vehicles.filter(function (item) {
        return !linked.includes(item.id)
      })

      if (this.manufacturerFilter.length > 0) {
        let manufacturer = this.manufacturerFilter
        options = options.filter(function (item) {
          return item.vehicleType && manufacturer.includes(item.vehicleType.manufacturer)
        })
      }

      if (this.typeFilter.length > 0) {
        let types = this.typeFilter
        options = options.filter(function (item) {
          return item.vehicleType && types.includes(item.vehicleType.type)
        })
      }

      if (this.statusFilter.length > 0) {
        let status = this.statusFilter
        options = options.filter(function (item) {
          return status.includes(item.status)
        })
      }

      return options
    },

    resourcefulQuery() {
      return {
        manufacturer: (opts) => {
          let result
          const manufacturer = this.vehicleTypes.vehicleTypes.data.map((item) => item.manufacturer)
          let manufacturers = [...new Set(manufacturer)].sort()

          if (opts.search) {
            manufacturers = manufacturers.filter((item) => this.isContains(opts.search, item.label))
          }

          let fullObjects = manufacturers.map((item) => {
            return {
              label: item,
              value: item,
            }
          })

          result = {
            metadata: {
              total_page: 1,
              total_count: fullObjects.length,
              page: 1,
            },
            data: {
              paginated_result: fullObjects,
            },
          }

          return result
        },
        type: (opts) => {
          let result
          let models = this.vehicleTypes.vehicleTypes.data
          if (this.manufacturerFilter.length > 0) {
            let filter = this.manufacturerFilter
            models = models.filter(function (item) {
              return filter.includes(item.manufacturer)
            })
          }
          models = models.map((item) => item.model)
          models = [...new Set(models)].sort()

          let res = []
          for (let i = 0; i < models.length; i++) {
            let types = []
            this.vehicleTypes.vehicleTypes.data.forEach(function (item) {
              if (models[i] == item.model) {
                types.push(item)
              }
            })

            res.push({
              models: models[i],
              types: types,
            })
          }

          if (opts.search) {
            res = res.filter((item) => this.isContains(opts.search, item.types))
          }

          result = {
            metadata: {
              total_page: 1,
              total_count: res.length,
              page: 1,
            },
            data: {
              paginated_result: res,
            },
          }

          return result
        },
        status: (opts) => {
          let data = [
            {
              key: 'I',
              label: 'Aktif',
            },
            {
              key: 'R',
              label: 'Perbaikan',
            },
            {
              key: 'A',
              label: 'Arsip',
            },
          ]

          if (opts.search) {
            data = data.filter((item) => this.isContains(opts.search, item.label))
          }

          let result = {
            metadata: {
              total_page: 1,
              total_count: data.length,
              page: 1,
            },
            data: {
              paginated_result: data,
            },
          }

          return result
        },
      }
    },

    typeOptions() {
      let models = this.vehicleTypes.vehicleTypes.data
      if (this.manufacturerFilter.length > 0) {
        let filter = this.manufacturerFilter
        models = models.filter(function (item) {
          return filter.includes(item.manufacturer)
        })
      }
      models = models.map((item) => item.model)
      models = [...new Set(models)].sort()

      let res = []
      for (let i = 0; i < models.length; i++) {
        let types = []
        this.vehicleTypes.vehicleTypes.data.forEach(function (item) {
          if (models[i] == item.model) {
            types.push(item)
          }
        })

        res.push({
          models: models[i],
          types: types,
        })
      }

      return res
    },

    mainTableQuery() {
      return {
        get: async (filter) => {
          let items = [...this.linkedVehicle]
          if (filter.search) {
            items = items.filter(
              (item) =>
                (item.licensePlate &&
                  item.licensePlate.toLowerCase().includes(filter.search.toLowerCase())) ||
                (item.imei && item.imei.toLowerCase().includes(filter.search.toLowerCase()))
            )
          }

          if (filter.orderBy && filter.orderBy.length > 0) {
            const sort = JSON.parse(filter.orderBy[0])
            const key = Object.keys(sort)[0]
            const order = sort[key]
            items.sort((a, b) => {
              let valA = a[key]
              let valB = b[key]
              if (key === 'category' || key === 'manufacturer' || key === 'vehicleType') {
                valA = a.vehicleType ? a.vehicleType[key === 'vehicleType' ? 'type' : key] : ''
                valB = b.vehicleType ? b.vehicleType[key === 'vehicleType' ? 'type' : key] : ''
              }
              if (order === 'asc') return valA > valB ? 1 : -1
              return valA < valB ? 1 : -1
            })
          }

          const page = filter.pagination.page
          const show = filter.pagination.show
          const paginatedItems = items.slice((page - 1) * show, page * show)

          return {
            data: paginatedItems,
            pagination: {
              page: page,
              total: items.length,
            },
          }
        },
      }
    },

    modalTableQuery() {
      return {
        get: async (filter) => {
          let items = [...this.vehicleOptions]
          if (filter.search) {
            items = items.filter(
              (item) =>
                (item.licensePlate &&
                  item.licensePlate.toLowerCase().includes(filter.search.toLowerCase())) ||
                (item.imei && item.imei.toLowerCase().includes(filter.search.toLowerCase()))
            )
          }

          if (filter.orderBy && filter.orderBy.length > 0) {
            const sort = JSON.parse(filter.orderBy[0])
            const key = Object.keys(sort)[0]
            const order = sort[key]
            items.sort((a, b) => {
              let valA = a[key]
              let valB = b[key]
              if (key === 'category' || key === 'manufacturer' || key === 'vehicleType') {
                valA = a.vehicleType ? a.vehicleType[key === 'vehicleType' ? 'type' : key] : ''
                valB = b.vehicleType ? b.vehicleType[key === 'vehicleType' ? 'type' : key] : ''
              }
              if (order === 'asc') return valA > valB ? 1 : -1
              return valA < valB ? 1 : -1
            })
          }

          const page = filter.pagination.page
          const show = filter.pagination.show
          const paginatedItems = items.slice((page - 1) * show, page * show)

          return {
            data: paginatedItems,
            pagination: {
              page: page,
              total: items.length,
            },
          }
        },
      }
    },
  },

  watch: {
    manufacturerFilter: function (val) {
      const objects = val.map((item) => {
        return {
          label: item,
          value: item,
        }
      })

      this.fullObject.manufacturers = objects
    },
    linkedVehicle: function () {
      this.refreshMainTable = true
      this.$nextTick(() => {
        this.refreshMainTable = false
      })
    },
    vehicleOptions: function () {
      this.refreshModalTable = true
      this.$nextTick(() => {
        this.refreshModalTable = false
      })
    },
  },

  methods: {
    handleMainTableSelect(selectedIds) {
      this.selectedModel.groupVehicleList = selectedIds
      // sync selected.groupVehicleList
      this.selected.groupVehicleList = this.linkedVehicle.filter(
        (item) => selectedIds[item.id] === true
      )
    },

    handleModalTableSelect(selectedIds) {
      this.selectedModel.vehicleList = selectedIds
      // sync selected.vehicleList
      this.selected.vehicleList = this.vehicleOptions.filter(
        (item) => selectedIds[item.id] === true
      )
    },
    handleSubmit() {
      this.$refs.formRef.formSubmitted()
    },
    toSave() {
      if (this.isSubmitted) return

      let vehicleId = this.vgroup.vgroup.vehicleList.map((item) => parseInt(item.id))
      this.isSubmitted = true
      if (this.id === undefined) {
        let inputAdd = {
          name: this.form.vgroup,
          vehicleList: vehicleId,
        }
        this.$apollo
          .mutate({
            mutation: CREATE_VEHICLE_GROUP,
            variables: {
              input: inputAdd,
            },
          })
          .then((response) => {
            if (response.data.createVgroup.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.saved'))

              this.$apollo.queries.vgroup.refetch()
              setTimeout(() => {
                this.$router.push({
                  name: 'List Fleet Group Setting',
                })
              }, 500)
            } else {
              return this.$mcToast.error(response.data.createVgroup.message)
            }
          })
          .catch((error) => {
            this.isSubmitted = false
            return this.$toast.error(error?.message || this.$t('global.somethingWentWrong'))
          })
      } else {
        let inputEdit = {
          id: parseInt(this.id),
          name: this.form.vgroup,
          vehicleList: vehicleId,
        }

        this.$apollo
          .mutate({
            mutation: UPDATE_VEHICLE_GROUP,
            variables: {
              input: inputEdit,
            },
          })
          .then((response) => {
            if (response.data.updateVgroup.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.changed'))

              this.$apollo.queries.vgroup.refetch()
              setTimeout(() => {
                this.$router.push({
                  name: 'List Fleet Group Setting',
                })
              }, 500)
            } else {
              return this.$mcToast.error(response.data.updateVgroup.message)
            }
          })
          .catch((error) => {
            this.isSubmitted = false
            return this.$toast.error(error?.message || this.$t('global.somethingWentWrong'))
          })
      }
    },
    openModalAdd() {
      this.$bvModal.show('modal-filter')
    },
    toDelete(param) {
      this.selected[param].forEach((row) => {
        this.vgroup.vgroup.vehicleList = this.vgroup.vgroup.vehicleList.filter(function (item) {
          return parseInt(item.id) !== parseInt(row.id)
        })
      })
      this.selected[param] = []
      this.selectedModel[param] = []

      this.$bvModal.hide('modal-delete-group')
    },
    selectVehicle() {
      let self = this
      this.selected.vehicleList.forEach(function (item) {
        self.vgroup.vgroup.vehicleList.push(item)
      })
      this.selected.vehicleList = []
      this.selectedModel.vehicleList = []
      this.$bvModal.hide('modal-filter')
    },

    clearGroup() {
      this.selectedModel.groupVehicleList = []
      this.selected.groupVehicleList = []
    },

    clearList() {
      this.selectedModel.vehicleList = []
      this.selected.vehicleList = []
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <p class="mb-4">
        {{ $t('setting.list.fleetGroup.form.textCreateFleet') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack
            href="/setting/fleetgroup"
            class="me-2"
            data-me="setting-fleetgroup-form-btn-back"
          />

          <McButton
            data-me="setting-fleetgroup-form-btn-save"
            variant="primary"
            :text="$t('global.save')"
            icon="icon-outline_save"
            :loading="isSubmitted"
            @click="handleSubmit"
          />
        </div>
      </div>
    </div>

    <div class="row mt-4 mc-list-header d-flex justify-content-between">
      <FormulateForm
        ref="formRef"
        v-model="form"
        class="d-flex justify-content-between col-md-6"
        @submit="toSave"
      >
        <div class="col-sm-12 col-md-6">
          <FormulateInput
            :label="$t('setting.list.fleetGroup.fleetGroupName')"
            :placeholder="$t('setting.list.fleetGroup.form.insertFleetGroup')"
            name="vgroup"
            validation="required:trim"
            help="required"
            error-behavior="submit"
            validation-behavior="submit"
            data-me="setting-fleetgroup-form-input-name"
          />
        </div>
      </FormulateForm>

      <div class="col-sm-12 col-md-3 mb-4 mt-4">
        <div class="text-end">
          <McButton
            v-if="selected.groupVehicleList.length"
            v-b-modal.modal-delete-group
            variant="secondary-red"
            class="mx-2"
            :text="$t('global.delete')"
            icon="icon-outline_trash"
            data-me="setting-fleetgroup-form-btn-delete"
          />

          <McButton
            variant="primary"
            :text="$t('global.addField')"
            icon="icon-outline_plus"
            @click="openModalAdd"
            data-me="setting-fleetgroup-form-btn-add-vehicle"
          />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <!-- Table List Fleet Group -->
        <McGrapqlTable
          :fields="groupVehicleList"
          :apiClient="mainTableQuery"
          :refreshData="refreshMainTable"
          :searchable="true"
          :withCard="false"
          :hasDelete="false"
          @handleSelectValue="handleMainTableSelect"
        >
          <template #cell(category)="data">
            {{ data.item.vehicleType ? data.item.vehicleType.category : '-' }}
          </template>

          <template #cell(manufacturer)="data">
            {{ data.item.vehicleType ? data.item.vehicleType.manufacturer : '-' }}
          </template>

          <template #cell(vehicleType)="data">
            {{ data.item.vehicleType ? data.item.vehicleType.type : '-' }}
          </template>

          <template #cell(imei)="data">
            {{ data.item.imei ?? '-' }}
          </template>
        </McGrapqlTable>
      </div>
    </div>

    <b-modal
      id="modal-filter"
      class="mc-modal"
      title="Tambah Kendaraan"
      size="xl"
      centered
      scrollable
    >
      <div class="card">
        <FormulateForm ref="formRefModal">
          <div class="row mb-3">
            <div class="col-md-4">
              <FormulateInput
                v-model="manufacturerFilter"
                name="manufacturer"
                :placeholder="$t('global.object.manufacture')"
                :label="$t('global.object.manufacture')"
                type="select-resourceful-v2"
                :multiple="true"
                :optionsGetter="resourcefulQuery.manufacturer"
                trackBy="label"
                :optionLabelFn="({ item }) => item.label"
                :fullObject="fullObject.manufacturers"
                @update:fullObject="($event) => (fullObject.manufacturers = $event)"
              />
            </div>
            <div class="col-md-4">
              <FormulateInput
                v-model="typeFilter"
                name="type"
                :placeholder="$t('global.field.name')"
                :label="$t('fleetAvailability.fields.vehicleType')"
                type="select-resourceful-v2"
                :multiple="true"
                :optionsGetter="resourcefulQuery.type"
                trackBy="type"
                group-values="types"
                group-label="models"
                :group-select="false"
                :optionLabelFn="({ item }) => item.type"
                :fullObject="fullObject.types"
                @update:fullObject="($event) => (fullObject.types = $event)"
              />
            </div>
            <div class="col-md-4">
              <FormulateInput
                v-model="statusFilter"
                name="status"
                :placeholder="$t('global.object.fleetStatus')"
                :label="$t('global.object.fleetStatus')"
                type="select-resourceful-v2"
                :multiple="true"
                :optionsGetter="resourcefulQuery.status"
                trackBy="key"
                :optionLabelFn="({ item }) => item.label"
                :fullObject="fullObject.statuses"
                @update:fullObject="($event) => (fullObject.statuses = $event)"
              />
            </div>
          </div>
        </FormulateForm>

        <div class="card-body">
          <!-- Table Tambah Kendaraan -->
          <McGrapqlTable
            :fields="vehicleList"
            :apiClient="modalTableQuery"
            :refreshData="refreshModalTable"
            :searchable="true"
            :withCard="false"
            :hasDelete="false"
            @handleSelectValue="handleModalTableSelect"
          >
            <template #cell(category)="data">
              {{ data.item.vehicleType ? data.item.vehicleType.category : '-' }}
            </template>

            <template #cell(manufacturer)="data">
              {{ data.item.vehicleType ? data.item.vehicleType.manufacturer : '-' }}
            </template>

            <template #cell(vehicleType)="data">
              {{ data.item.vehicleType ? data.item.vehicleType.type : '-' }}
            </template>

            <template #cell(imei)="data">
              {{ data.item.imei ?? '-' }}
            </template>
          </McGrapqlTable>
        </div>
      </div>

      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" class="text-end">
            <McButton
              data-me="setting-fleetgroup-form-modal-add-btn-cancel"
              variant="secondary"
              :text="$t('global.cancel')"
              class="me-3"
              @click="cancel()"
            />
            <McButton
              data-me="setting-fleetgroup-form-modal-add-btn-apply"
              variant="primary"
              :text="$t('global.action.apply')"
              @click="selectVehicle()"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal
      id="modal-delete-group"
      class="mc-modal"
      :title="$t('global.delete')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('global.confirmDelete1') }} {{ $t('global.confirmDelete2') }}</p>
        <b-list-group>
          <b-list-group-item v-for="(vehicle, index) in selected.groupVehicleList" :key="index">
            {{ vehicle.licensePlate }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              data-me="setting-fleetgroup-form-modal-delete-btn-no"
              variant="secondary"
              :text="$t('global.no')"
              class="me-2"
              @click="cancel()"
            />
            <McButton
              data-me="setting-fleetgroup-form-modal-delete-btn-yes"
              variant="primary"
              :text="$t('global.yes')"
              @click="toDelete('groupVehicleList')"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
